export enum ContactNoteDialogStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  INSUBMISSION = 'INSUBMISSION',
  DELETED = 'DELETED',
}

export enum ContactNoteActivityStatus {
  CREATED = 'CREATED',
  EDITED = 'EDITED',
  SUBMITTED = 'SUBMITTED',
}

export enum ContactNoteDialogLabelStatus {
  DRAFT = 'Draft',
  SUBMITTED = 'Submitted',
  INSUBMISSION = 'In submission',
}

export const ContactNoteStatusOptions = [
  {
    value: 'DRAFT',
    label: 'Draft',
  },
  {
    value: 'SUBMITTED',
    label: 'Submitted',
  },
  {
    value: 'INSUBMISSION',
    label: 'In submission',
  },
];

export const submissionStatusPlaceholder = [
  {
    value: 'DRAFT',
    label: 'Draft',
  },
  {
    value: 'SUBMITTED',
    label: 'Submitted',
  },
  {
    value: 'INSUBMISSION',
    label: 'In submission',
  },
  {
    value: 'DELETED',
    label: 'Deleted',
  },
  {
    value: 'EDITABLE',
    label: 'Draft',
  },
];

export enum ContactNoteInitiatedUiScreen {
  HOME = 'home',
  PARNTER = 'partner',
  BR = 'br',
  DRAGANDDROP = 'draganddrop',
}
